



















import { Component, Emit, Prop, Mixins, Ref } from "vue-property-decorator";
import { namespace } from "vuex-class";
import PatientMixin from "@/mixins/patientMixin";
import AxiosMixin from "@/mixins/axiosMixin";
import * as patient from "@/store/modules/patient/types";
import BasePatientRelationInsSelect from "@/components/patient/common_ibow/base/BasePatientRelationInsSelect.vue";
import { SearchItem } from "@/components/patient/common_ibow/personnel";

const Patient = namespace(patient.name);
@Component({ components: { BasePatientRelationInsSelect } })
export default class PatientRelationInsSelect extends Mixins(
  PatientMixin,
  AxiosMixin
) {
  @Patient.Mutation(patient.SET_PATIENT_MASTER) setPatientMaster!: Function;

  @Ref("select") private readonly select!: BasePatientRelationInsSelect;

  @Prop() value!: number;
  @Prop({ default: "prefix" }) private prefix_id!: string;
  @Prop({ default: "関連機関" }) label!: string;
  @Prop({ default: () => [] }) support_office_divs!: number[];
  @Prop({ default: false }) is_own!: boolean;
  @Prop({ default: false }) not_select!: boolean;
  @Prop({ default: () => [] }) document_forms!: number[];
  @Prop({ default: false }) not_empty!: boolean;
  @Prop({ default: false }) disabled!: boolean;

  @Emit() private input(newValue: number) {
    return newValue;
  }

  /** 検索条件を入力した状態で検索ダイアログを開く */
  public openDialogWithCondition(cond: SearchItem) {
    this.select.openDialogWithCondition(cond);
  }

  private get Value(): number {
    return this.value;
  }

  private set Value(newValue: number) {
    this.input(newValue);
  }

  // 利用者マスタ情報取得
  private updateMaster() {
    this.postJsonCheck(
      window.base_url + "/api/patient/master/get",
      { patient_id: Number(this.$route.params.id) },
      res => {
        if (res.data) {
          this.setPatientMaster({ master: res.data });
        }
      }
    );
  }
}
